import {
    CartStep1Interface,
    CartStep1ResponseInterface,
} from '@/core/domain/cart-step1/models/cart-step1.model';
import { CartStep1Repository } from '@/core/domain/cart-step1/repositories/cart-step1.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CartStep1ImplRepository extends CartStep1Repository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override sendCartStep1(
        array: CartStep1Interface,
    ): Observable<CartStep1ResponseInterface> {
        return this.httpClient.post<CartStep1ResponseInterface>(
            [
                environment.alamoApi.BASE_HOST,
                environment.alamoApi.ENDPOINTS.cartVehicle,
            ].join('/'),
            array,
        );
    }
}
